import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoggedInUserDetailsService {
  calculatedOffset: number;

  constructor() { }

  private dataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  setData(data: any):void{
    this.dataSubject.next(data);
  }

  getData():Observable<any>{
    return this.dataSubject.asObservable();
  }

  setUserOffset(offset: number):void {
    this.calculatedOffset = offset;
  }

}
